import { render } from "./AddAnnouncement.vue?vue&type=template&id=505e7351&scoped=true"
import script from "./AddAnnouncement.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddAnnouncement.vue?vue&type=script&charset=utf-8&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddAnnouncement.vue?vue&type=style&index=1&id=505e7351&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505e7351"]])

export default __exports__